export default Object.freeze({
    createdAt_ASC: {
        label: 'createdAt_ASC',
        value: {
            orderBy: 'createdAt',
            wayDefinition: 'ASC',
        },
    },
    createdAt_DESC: {
        label: 'createdAt_DESC',
        value: {
            orderBy: 'createdAt',
            wayDefinition: 'DESC',
        },
    },
    distance_ASC: {
        label: 'distance_ASC',
        value: {
            orderBy: 'distance',
            wayDefinition: 'ASC',
        },
    },
    priceRSD_ASC: {
        label: 'priceRSD_ASC',
        value: {
            orderBy: 'priceRSD',
            wayDefinition: 'ASC',
        },
    },
    priceRSD_DESC: {
        label: 'priceRSD_DESC',
        value: {
            orderBy: 'priceRSD',
            wayDefinition: 'DESC',
        },
    },
    averageRating_ASC: {
        label: 'averageRating_ASC',
        value: {
            orderBy: 'averageRating',
            wayDefinition: 'ASC',
        },
    },
    averageRating_DESC: {
        label: 'averageRating_DESC',
        value: {
            orderBy: 'averageRating',
            wayDefinition: 'DESC',
        },
    },
})
